import TeamCarousel from './TeamCarousel';

export default TeamCarousel;